import { Button, Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import React, { Component } from "react";
import { errorToast } from "../../toast";
import { hideLoading, showLoading } from "../../loading";
import request from "../../request";
import swal from "sweetalert";
import DialogTitleWithCloseButton from "../../components/DialogTitleWithCloseButton";

export default class ResetPassword extends Component {

	state = {
		email: '',
	}

	txtEmailRef = React.createRef();

	submit = async () => {

		// presence check
		const { email } = this.state;

		if (!email) {
			errorToast('Provide you email number');
			return this.txtEmailRef.current.querySelector('input').focus();
		}

		// submit
		const data = { email };

		try {
			showLoading();

			await request.post('/api/auth/password-reset', data);
			swal('Success', `A link to reset your password has been sent to ${email}`, 'success');

			this.props.onClose();
			
		} catch(err) {
			swal('Error', String(err), 'error');
		} finally {
			hideLoading();
		}
	}

	async componentDidMount() {
		if (this.props.email) {
			this.setState({ email: this.props.email });
		}
	}

	render() {
		return <Dialog open>
			<DialogTitleWithCloseButton onClose={this.props.onClose}>Reset password</DialogTitleWithCloseButton>
			<DialogContent dividers>
				<div className="max-w-full w-[300px]">
					<TextField
						ref={this.txtEmailRef}
						value={this.state.email}
						onChange={e => this.setState({ email: e.target.value })}
						label="Email"
						variant="outlined"
						size="small"
						fullWidth
						className="my-2"
					/>	
				</div>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" size="small" onClick={this.submit}>
					SUBMIT
				</Button>
			</DialogActions>
		</Dialog>
	}
}